import * as React from 'react';
import { useSegment } from '../../../hooks/useSegment';
import * as styles from '../view-segment.module.scss';

interface Props {
  segmentId: string;
}

/**
 * Render a single segment's details for a view-only segment
 */
const ViewSegmentDetails = ({ segmentId }: Props) => {
  const { segmentQuery, userInterface } = useSegment(segmentId);
  if (segmentQuery.data) {
    return (
      <dl className={styles.detailsSectionContent}>
        {userInterface === 'management' && (
          <div className={styles.detailListItem}>
            <dt>Team Name</dt>
            <dd>{segmentQuery.data.clientName}</dd>
          </div>
        )}
        <div className={styles.detailListItem}>
          <dt>Segment Name</dt>
          <dd>{segmentQuery.data.name}</dd>
        </div>
        <div className={styles.detailListItem}>
          <dt>Segment Description</dt>
          <dd>{segmentQuery.data.description}</dd>
        </div>
        <div className={styles.detailListItem}>
          <dt>Segment Sharing</dt>
          <dd>{segmentQuery.data.isShared ? 'Shared' : 'Not shared'}</dd>
        </div>
      </dl>
    );
  }
};

export default ViewSegmentDetails;
